<template>
    <div class="page-content">
        <div class="center-text own-title margin-bottom-20">
            Awards & Recognition
        </div>
        <div class="content">
            <AwardBanner
                modal="lifetime-partner-modal"
                title="LIFETIME PARTNER"
                positionSliderMobile="2%"
                positionSliderIpad="2%"
                image="01.png"
                overlapImage="lifetime_partner"
                description="Qualifiying Period: 01 JAN 2026 – 31 DEC 2026"
                backgroundSizeMobile="cover"
                backgroundPosition="left"
                backgroundSizeIpad="cover"
            />
            <AwardBanner
                modal="national-awards-modal"
                title="NATIONAL AWARDS"
                positionSliderMobile="2%"
                positionSliderIpad="2%"
                image="02.png"
                overlapImage="national_awards"
                description="Qualifiying Period: 01 JAN 2026 – 31 DEC 2026"
                backgroundSizeMobile="cover"
                backgroundPosition="left"
                backgroundSizeIpad="cover"
            />
            <AwardBanner
                modal="million-dollar-modal"
                title="MILLION DOLLAR"
                positionSliderMobile="2%"
                positionSliderIpad="2%"
                image="03.png"
                overlapImage="million_dollar"
                description="Qualifiying Period: 01 JAN 2026 – 31 DEC 2026"
                backgroundSizeMobile="cover"
                backgroundPosition="left"
                backgroundSizeIpad="cover"
            />
            <AwardBanner
                modal="2027-mdrt-modal"
                title="2027 MDRT"
                positionSliderMobile="2%"
                positionSliderIpad="2%"
                image="04.png"
                overlapImage="2027_mdrt"
                description="Qualifiying Period: 01 JAN 2026 – 31 DEC 2026"
                backgroundSizeMobile="cover"
                backgroundPosition="left"
                backgroundSizeIpad="cover"
            />
        </div>
        <div class="divider divider-margins"></div>
    </div>
</template>
<style scoped>
.theme-dark .divider {
    background-color: unset !important;
}
.divider-margins {
    margin: 0px 15px 60px 15px;
}
.content {
    margin: 0px 0 20px 0 !important;
}
</style>
<script>
import AwardBanner from '@/components/AwardBanner.vue'
export default {
    name: 'Awards',
    components: {
        AwardBanner
    }
}
</script>
